import './css/bootstrap.min.css';
import './App.css';
import './css/style.css';
import './css/colors_override.css';
import './css/timeline.css';
import React from 'react';
import Main from './Main';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import UserPage from './components/UserPage';
import LoginModal from './components/LoginModal';

function App() {
    const authFeatureEnabled = process.env.REACT_APP_AUTH_FEATURE_ENABLED === 'true';
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<Main />} />
                        {authFeatureEnabled && (
                            <>
                                <Route path="/login" element={<LoginModal />} />
                                <Route path="/user" element={<UserPage />} />
                            </>
                        )}
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
  );
}

export default App;
